import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Hero from '../components/hero';
import SideBySide from '../components/side-by-side';
// import TeamTile from "../components/team-tile";
// import TeamGrid from "../components/team-grid";
// import IntegrationsGrid from "../components/integrations-grid"
// import IntegrationsGrid from "../components/integrations-grid"
import IntegrationsGrid from '../components/integrations-grid';
import Carousel from '../components/carousel';
import DialogButton from '../components/dialogButton';

const Inventory = () => {
    const data = useStaticQuery(graphql`
        query {
            hero: file(relativePath: { eq: "inventory-hero.jpeg" }) {
                childImageSharp {
                    fluid(maxWidth: 2600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            map: file(relativePath: { eq: "map.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            barcode: file(relativePath: { eq: "weave-barcode.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            history: file(relativePath: { eq: "package-history.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            catalog: file(relativePath: { eq: "inventory-catalog.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            integration: file(relativePath: { eq: "state-integration.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Dispensary Inventory & Compliance"
                url="/dispensary-inventory-and-compliance"
                description="Weave gives you simple, real-time visibility into what you have, where it is, and how to optimize your product orders for the best return on investment. Every cannabis transaction in Weave is compliant with state tracking and reporting systems, whether you are a single-state or multi-state operator."
            />
            <Hero
                buttonsList={[
                    <DialogButton analyticsValue={3} key="talk">
                        Show Me a Demo
                    </DialogButton>,
                ]}
                copy="Weave gives you simple, real-time visibility into what you have, where it is, and how to optimize your product orders for the best return on investment. Every cannabis transaction in Weave is compliant with state tracking and reporting systems, whether you are a single-state or multi-state operator."
                header="Inventory & Compliance"
                image={data.hero.childImageSharp.fluid}
            />
            <div className="parallax-section parallax-white">
                <SideBySide
                    bulletsList={[
                        'Daily transaction reports',
                        'Real-time reporting to government systems',
                        'Up-to-the-moment inventory',
                    ]}
                    buttonsList={[
                        <DialogButton key="one">Learn More</DialogButton>,
                    ]}
                    copy="Weave reports every stage of your inventory lifecycle to regulators in real time. The moment you receive a package, complete a sale or handle product destruction, our system ensures you are insync with government reporting."
                    image={data.history.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Real-Time Reporting"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy={[
                        'Join a community-built product catalog, or build your own. Dispensaries in the Weave network have access to a shared product catalog with thousands of items.',
                        <br></br>,
                        <br></br>,
                        <p>
                            Save time and take advantage of the shared catalog
                            to import products into your dispensary – including
                            product details, specifications, and even images –
                            or build a proprietary catalog to your own
                            specifications.
                        </p>,
                    ]}
                    image={data.catalog.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="Product Catalog"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Weave uses state-of-the-art scanning and barcoding technology to ensure minimal errors and increase efficiency. Every product is barcoded so your employees can track the origin of each shipment instead of relying on memory."
                    image={data.barcode.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Automatic Accuracy and Barcode Technology"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Easily separate inventory between a secured backroom safe and available front-of-house inventory. Stay up to date with your dispensary’s inventory with real-time visibility into each inventory room. There is no limit to the number of rooms you specify, giving you complete control."
                    gif={
                        'https://storage.googleapis.com/weave-web-images/rooms.gif'
                    }
                    imagePosition={'right'}
                    sideHeader="Inventory Rooms"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    bulletsList={[
                        'Integration with each step of the cannabis pipeline includes receiving packages, reconciling packages, and point-of-sale transactions.',
                        'Easily reconcile sales with METRC and Board of Pharmacy State Systems.',
                    ]}
                    buttonsList={[
                        <DialogButton key="one">Lets Chat</DialogButton>,
                    ]}
                    copy="Government compliance is integrated into every part of Weave. Our system is aligned with all current cannabis laws and policy mandates in your state to simplify the complexities of remaining fully compliant."
                    image={data.integration.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Full Integration with Reporting Systems"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Each sale is checked against patient records – including both daily and monthly histories – to prevent looping and overselling so you can operate with peace of mind."
                    gif="https://storage.googleapis.com/weave-web-images/legalliimit.gif"
                    imagePosition={'right'}
                    sideHeader="Patient Record Scanning"
                />
            </div>

            <IntegrationsGrid
                header="API Integrations"
                copy="We understand we can't do it all. By partnering with the best in the industry, we make sure you and your customers have a seamless end to end experience."
            />

            <Carousel />
        </Layout>
    );
};

export default Inventory;
